import { RSAA } from 'redux-api-middleware'
import resultHandle from './result'
import errorHandler from './error'
import headerHandler from './header'
import * as nprogress from 'nprogress'

const FAILURE = 'FAILURE'
export default function callAPI({ type = 'JSON', method = 'GET', endpoint, header, body, requestAction, successAction, success, error, dispatch, forward = true }) {
  console.log('callAPI:body', JSON.stringify(body))
  const methods = headerHandler({
    type,
    method,
    endpoint,
    body,
    header,
    forward
  })
  return {
    [RSAA]: Object.assign({}, methods, {
      types: [
        {
          type: requestAction,
          payload: () => {
            nprogress.start()
            return { isFetching: true }
          }
        },
        {
          type: successAction,
          payload: (action, state, res) => {
            nprogress.done()
            return res.json().then(json => {
              const result = resultHandle(json, dispatch, success, error)
              return result
            })
          }
        },
        {
          type: FAILURE,
          payload: (action, state, res) => {
            nprogress.done()
            return errorHandler(res, dispatch, error)
          }
        }
      ]
    })
  }
}

export { default as syncSubmit } from './syncSubmit'
